import React, { useContext } from 'react'
import { ThemeProvider } from 'styled-components'
import theme from '@berlitz/max-theme-berlitz'
import '@openfonts/ibm-plex-sans_latin-ext'
import { createGlobalStyle } from 'styled-components'
import { GlobalStyleReset, GlobalStyle } from '@berlitz/max-css-reset'
import Helmet from 'react-helmet'
import useUserInteraction from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/hooks/useUserInteraction'
import ConfigContext from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/contexts/ConfigContext'

const BlitzGlobalStyle = createGlobalStyle`
  body {
    font-family: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif;
    font-display: fallback;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.3px;
    line-height: 1.4;
    .grecaptcha-badge {
      bottom: 90px !important;
      z-index: 99 !important;
    }
  }
`

const BaseLayout = ({ children }) => {
  const { recaptchaKey } = useContext(ConfigContext)
  const userInteraction = useUserInteraction()
  const recaptchaLang = 'us'

  return (
    <ThemeProvider theme={theme}>
      <>
        <Helmet>
          {userInteraction && (
            <script
              defer
              src={`https://www.google.com/recaptcha/enterprise.js?render=${recaptchaKey}`}
            ></script>
          )}
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TKLK4LW3');`}
          </script>
        </Helmet>
        <BlitzGlobalStyle />
        <GlobalStyleReset />
        <GlobalStyle />
        {children}
      </>
    </ThemeProvider>
  )
}

export default BaseLayout